import React, { useEffect, useState, useCallback } from 'react';

export const Stepper = ({ children, formState, strings, disabled }) => {
  const [openIndex, setOpenIndex] = useState(0);
  const [openedSteps, setOpenedSteps] = useState([]);
  const [isMachineryTypeOpened, setIsMachineryTypeOpened] = useState(false);
  const [stepsOpened, setStepsOpened] = useState(['landing']);

  // Initialize opened steps
  useEffect(() => {
    setOpenedSteps(Array(children.length).fill(false));
  }, [children.length]);

  // Handle enabling/disabling
  useEffect(() => {
    if (disabled) {
      setOpenIndex(undefined);
    } else {
      setOpenIndex(0);
    }
  }, [disabled]);

  // Handle machinery selection logic
  /* useEffect(() => {
    if (!isMachineryTypeOpened && formState['machineryType'] !== undefined) {
      const machineryIndex = children.findIndex(
        (child) => child.props.stepItem?.step === 'machinery'
      );
      if (machineryIndex !== -1) {
        const updatedSteps = [...openedSteps];
        updatedSteps.splice(machineryIndex + 1, 0, false);
        setOpenedSteps(updatedSteps);
        setOpenIndex(machineryIndex);
        setIsMachineryTypeOpened(true);
      }
    }
  }, [children, formState, isMachineryTypeOpened, openedSteps]); */

  const openStep = useCallback((step, index) => {
    const updatedOpenedSteps = [...openedSteps];
    const updatedStepsOpened = [...stepsOpened];

    if (openIndex !== undefined) {
      updatedOpenedSteps[openIndex] = true;
      if (!updatedStepsOpened.includes(step.props.stepItem.step)) {
        updatedStepsOpened.push(step.props.stepItem.step);
      }
    }

    setOpenIndex(index);
    setOpenedSteps(updatedOpenedSteps);
    setStepsOpened(updatedStepsOpened);

    setTimeout(() => {
      const content = document.getElementsByClassName('step-title')[index];
      if (content) {
        const box = content.getBoundingClientRect();
        const body = document.body;
        const docEl = document.documentElement;
        const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
        const clientTop = docEl.clientTop || body.clientTop || 0;
        const top = box.top + scrollTop - clientTop;

        if (window.scrollY > top) {
          window.scroll(0, Math.round(top));
        }
      }
    }, 0);
  }, [openIndex, openedSteps, stepsOpened]);

  const isStepComplete = (step, index) => {
    if (step.props.stepItem.step === 'car') {
      return formState['carPictureCopKen'] !== undefined;
    }
    return stepsOpened.includes(step.props.stepItem.step);
  };

  return (
    <div className="stepper">
      {disabled && <div className="overlay-disabled" />}
      {children.map((step, index) => {
        const stepContent = (
          <div className="step-wrapper">
            {step}
            <div>
              {index !== children.length - 1 && (
                <button
                  className="standard-btn green stepper-btn"
                  onClick={() => openStep(step, openIndex + 1)}
                >
                  {strings.nextStep}
                </button>
              )}
            </div>
          </div>
        );

        return (
          <div key={index} className="stepper-step">
            <div
              className="step-title"
              onClick={() => openStep(step, index)}
            >
              <div
                className={
                  'index' +
                  (openIndex === index ? ' open' : '') +
                  (isStepComplete(step, index) ? ' opened' : '')
                }
              >
                {index + 1}
              </div>
              <span>{step.props.title}</span>
            </div>
            <div
              className={
                'step-content' +
                (index === children.length - 1 ? ' last' : '') +
                (openIndex === index ? '' : ' closed')
              }
            >
              {stepContent}
            </div>
            <div
              className={
                'end-line' + (index === children.length - 1 ? ' last' : '')
              }
            ></div>
          </div>
        );
      })}
    </div>
  );
};